// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('travelBillLog', {
//         templateUrl: 'views/components/views/travelBillLog/travelBillLog.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['$stateParams', 'travelBillLogService', function ($stateParams, travelBillLogService) {

//             // #region VARIABLES & DEFINITIONS

//             const vm = this;
//             let travelBillLogKeyno = $stateParams.travelbillog_keyno;
            
//             vm.model = {
//                 menu: {}
//             };

//             // #endregion VARIABLES & DEFINITIONS

//             // #region LOAD PROCEDURE CALLS

//             async function loadMenu() {
//                 vm.model.menu = (await travelBillLogService.getMenu({ travelbillog_keyno: travelBillLogKeyno }))[0];
//             }

//             // #endregion LOAD PROCEDURE CALLS

//             // #region ON INIT FUNCTION

//             vm.$onInit = async function () {
//                 loadMenu();
//             }

//             // #endregion ON INIT FUNCTION

//         }]
//     });
// })();
